export const SOURCE_LABELS = {
    dadata: 'DaData',
    photon: 'OpenStreetMap / Photon'
};

export function sourceLabel(source) {
    if (!source) return null;
    return SOURCE_LABELS[source] || source;
}

export function sourceBadgeStyle(source) {
    if (source === 'dadata') {
        return {
            background: '#ecfdf5',
            color: '#047857',
            border: '1px solid #6ee7b7'
        };
    }
    return {
        background: '#eff6ff',
        color: '#1d4ed8',
        border: '1px solid #93c5fd'
    };
}
